export default function PlayButton() {
    return (
        <svg viewBox="0 0 79 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_3944_24170)">
                <path d="M68.7326 37.1727C70.1343 37.928 70.1343 39.9387 68.7326 40.694L5.94874 74.5257C4.61626 75.2437 3 74.2787 3 72.7651L3 5.10158C3 3.58796 4.61626 2.62291 5.94875 3.34093L68.7326 37.1727Z" fill="white"/>
            </g>
        </svg>
    );
};